import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../components/Reveal';
import IMG from '../data/images';
import { programmes, features } from '../data/siteData';




const Contact = () => (
  <div>
    <section style={{ paddingTop:130,paddingBottom:70,background:'linear-gradient(135deg,var(--navy),var(--navy-dark))',textAlign:'center' }}>
      <h1 style={{ fontFamily:'var(--fh)',fontSize:'2.6rem',color:'#fff' }}><span style={{color:'var(--gold)'}}>Contact</span> Us</h1>
      <p style={{ color:'rgba(255,255,255,0.6)',maxWidth:500,margin:'12px auto 0',lineHeight:1.8 }}>We'd love to hear from you. Reach out anytime.</p>
    </section>
    <section style={{padding:'90px 24px'}}>
      <div className='container' style={{maxWidth:1000}}>
        <div className='g2' style={{gap:48,alignItems:'start'}}>
          <Reveal direction='left'>
            <h2 style={{fontFamily:'var(--fh)',color:'var(--navy)',fontSize:'1.8rem',marginBottom:24}}>Get in Touch</h2>
            {[{i:'📞',l:'Phone',v:'+91 98XXX XXXXX'},{i:'✉️',l:'Email',v:'hello@finlandearlyyears.com'},{i:'📍',l:'Address',v:'Your City, India'},{i:'🕐',l:'Hours',v:'Mon–Sat, 8 AM – 5 PM'}].map((x,j)=>(
              <div key={j} style={{display:'flex',gap:14,alignItems:'flex-start',marginBottom:20}}>
                <span style={{fontSize:'1.4rem'}}>{x.i}</span>
                <div><div style={{fontWeight:700,color:'var(--navy)',fontSize:'0.82rem',textTransform:'uppercase',letterSpacing:'0.5px',marginBottom:2}}>{x.l}</div><div style={{color:'var(--body)',fontSize:'0.92rem'}}>{x.v}</div></div>
              </div>
            ))}
          </Reveal>
          <Reveal direction='right' delay={0.1}>
            <div style={{background:'#fff',borderRadius:20,padding:'36px 28px',boxShadow:'var(--shadow-l)',border:'1px solid var(--border)'}}>
              <h3 style={{fontFamily:'var(--fh)',color:'var(--navy)',fontSize:'1.2rem',marginBottom:20}}>Send a Message</h3>
              <div className='f-group'><label className='f-label'>Name</label><input className='f-input' placeholder='Full name'/></div>
              <div className='f-group'><label className='f-label'>Email</label><input className='f-input' type='email' placeholder='your@email.com'/></div>
              <div className='f-group'><label className='f-label'>Phone</label><input className='f-input' type='tel' placeholder='+91'/></div>
              <div className='f-group'><label className='f-label'>Message</label><textarea className='f-textarea' rows={4} placeholder='How can we help?'/></div>
              <button className='btn btn-gold btn-full' style={{padding:14}}>Send Message</button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
    <section style={{background:'var(--light-blue)',padding:'60px 24px',textAlign:'center'}}>
      <div className='container-sm'>
        <div style={{background:'#dde4ed',borderRadius:16,height:300,display:'flex',alignItems:'center',justifyContent:'center',color:'var(--navy)',fontWeight:600}}>📍 Google Map Embed Goes Here</div>
      </div>
    </section>
  </div>
);
export default Contact;
